<template>
  <div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card border-variant="primary" id="_share">
          <div slot="header" v-if="is_show">
            <strong>Group Invoice Info</strong>
            <b-button size="sm" class="float-right" variant="success" @click="share"> Export </b-button>
          </div>
          <b-row style="height:250px;">
            <b-col md="6">
              <b-form-group>
                <h4 for="ph_partner_name">User Summary</h4>
                <label class="ml-3" >Bill To Partner</label>
                <p v-if="model.partner" class="ml-3">
                  {{model.partner.username}}
                </p>
                <label class="ml-3" >Bill To Address</label>
                <p v-if="model.partner" class="ml-3">
                  {{model.group.address}}
                </p>
                <hr>
                <p class="text-left">
                  <label class="ml-3" >Description</label>
                  <p class="ml-3">
                    {{model.description}}
                  </p>
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <h4 for="ph_partner_name">Invoice Summary</h4>
                <label class="ml-3 w-100 pr-5" >Invoice Number : <span class="float-right">{{ model.invoice_id }}</span> </label>
                <label class="ml-3 w-100 pr-5" >Invoice Date : <span class="float-right">{{ model.created_at | sdate }}</span> </label>
                <hr>
                <label class="ml-3 w-100 pr-5" >Total Amount : <span class="float-right">{{ model.total_price + model.total_paid | dollar }}</span> </label>
              </b-form-group>
              <hr>
              <p class="text-center" v-if="model.partner && model.partner.logo">
                <img class="text-center" width="200" :src="model.partner.logo" alt="Hello, partner">
              </p>
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-3">
            <b-col md="12">
              <h3>
                Billing period: {{ model.start_at | date }} ~ {{ model.end_at | date }}
                <small class="float-right">* Include VAT</small>
              </h3>
            </b-col>
            <img v-if="model.is_paid" width="200" :src="'img/pay_clear.png'" alt="F1security" style="position:absolute; top: 500px; left: 40%; transform:rotate(-45deg); ">
          </b-row>
          <b-row>
            <b-col md="12">
              <table style="width: 100%; text-align: left; border-collapse: collapse; border-spacing: 0;">
                <tr style="background-color: gainsboro;">
                  <th style="padding: 5px;" colspan="3">Detail For Bill</th>
                </tr>
                <tr>
                  <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; width:60%;">UWSS Service Type</td>
                  <td colspan="2" style="border-top: black solid 1px;">{{ model.service.service_name }} </td>
                </tr>
                <tr>
                  <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Quantity & Amount Used</td>
                  <td style="border-top: black solid 1px;"> {{model.service_unit | number}} </td>
                  <td style="border-top: black solid 1px;"> {{model.base_price | dollar}} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WEBCastle (Web Application Firewall)</td>
                  <td style="border-top: black solid 1px;">{{ model.wc_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WSFinder (Anti-WebShell)</td>
                  <td style="border-top: black solid 1px;">{{ model.wsf_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WMDS (Web Malware Scanner)</td>
                  <td style="border-top: black solid 1px;">{{ model.wmds_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WFDetector (Web Forgery Detection)</td>
                  <td style="border-top: black solid 1px;">{{ model.wf_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Discount</td>
                  <td style="border-top: black solid 1px;">{{ model.discount_price | dollar }} </td>
                </tr>
                <tr style="background-color: skyblue;">
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Charges *</td>
                  <td style="border-top: black solid 1px;"> {{(model.is_paid ? model.paid_price : ((model.total_price || 0) + (model.paid_price || 0))  ) | dollar }} </td>
                </tr>
              </table>
            </b-col>
          </b-row>
          <hr>
          <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
          <b-row v-if="payment_history.length">
            <b-col md="12">
              <label for=""><h4>Partial Payment History</h4></label>
            </b-col>
            <hr>
            <b-col md="12">
              <!-- TODO : 테이블로 예쁘게 해야 함 -->
              <ul class="list-group">
                <li class="list-group-item" v-for="item in payment_history" v-bind:key="item.id" v-bind:class="{ strong: item.hp > 300 }">
                  <small v-if="item && item.payer">
                    <!-- paypal -->
                    <!-- {{item}} -->
                    [Purchased Date:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                    [Company:{{item.payer.email_address}}]
                    [Action:{{item.purchase_units[0].description}}]
                    [Method:{{item.pg}}]
                    [Price:{{item.purchase_units[0].amount.value | dollar}}]
                    [Currenty:{{item.purchase_units[0].amount.currency_code}}]
                    [Country:{{item.payer.address.country_code}}]
                  </small>
                  <small v-else>
                    <!-- boot_pay or credit -->
                    [Purchased Date:{{item.purchased_at | datetime}}]
                    [Company:{{item.pg_name}}]
                    [Action:{{item.action}}]
                    [Method:{{item.pg}}]
                    [Price:{{item.price}}]
                    [Currenty:{{'KRW'}}]
                    [Country:{{'KR'}}]
                  </small>
                </li>
              </ul>
            </b-col>
          </b-row>
          <!-- <b-button v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
          <b-button v-else size="sm" variant="warning" @click="edit">Edit </b-button> -->
          <!-- <b-button v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button> -->
          <!-- <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock"> Remove </b-button> -->
          <hr v-if="only_view != true && is_show">
          <b-button v-if="only_view != true && is_show" size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <!-- <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      Would You Like to Remove the group?
    </b-modal> -->
  </div>
</template>

<script>

import { Api } from '@/service';
import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { saveAs } from 'file-saver';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import moment from 'moment-timezone'

export default {
  props : ['item', 'only_view'],
  components: {
    cSwitch,
    vSelect,
  },
  data : () => {
    return {
      exporting : false,
      is_show : true,
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'service.name', sv: '', skt: 'Service', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { service : { service_name : '' }, group : { }, partner : { logo : '' } },
      lock : true,
      codes,
      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      // 일부 거래 기록
      payment_history : []
    }
  },
  computed: {},
  methods: {
    async share() {
      try {
        if(this.exporting) { return; }
        this.exporting = true
        this.is_show = false

        console.log("Generating shared image")
        this.$toastr.i("Generating shared image")

        let blob = await htmlToImage.toBlob(document.getElementById('_share'))
        window.saveAs(blob, `${this.model.group.groupname}_invoice_${this.model.apply_date}.png`);
        this.is_show = true
        this.exporting = false

        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export image failed");  }
    },
    edit:function() { this.lock = false },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
      this.$emit('refresh')
    },
    list: function() { this.$router.push({ name: 'invoice_group' }); this.$emit('refresh'); },
    remove: function() {
      Api.Partner_Call('invoice.group', 'delete', { id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            return this.$toastr.e('delete', "failed")
          }
          this.list();
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    getRowCount () { return this.so.totalRows || 0; },
    async partnerSave() {
      try {
        this.model.partner_id = this.model.partner.id;

        let rs = await Api.Partner_Call('invoice.group', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id);
        } else {
          this.$toastr.e('Save', "failed"); this.refresh();
        }
        this.syncPartner = false;
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(!(this.model.service || '').trim()) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        let rs = await Api.Partner_Call('group.invoice', this.model.id ? 'update' : 'insert', Object.assign({}, this.model));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.lock = true;
        this.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()}
    },
    get: async function({ id, tag, invoice_id } = this.$route.params) {
      id = this.item && this.item.id ? this.item.id : id

      // return console.log(id);
      console.log('invoice.detail.vue', 'load item', id, invoice_id);
      if(id === 'add' || tag === 'invoice') { this.model.is_verified = true; this.add = (tag != 'invoice'); this.lock = false; return; }
      else {
        Api.Partner_Call('group.invoice','detail', { id : id, invoice_id : invoice_id })
          .then(rs => {
            if(rs.error) { return this.$toastr.e("load faild", this.$route.name); }
            this.model = Object.assign({}, this.model, rs.body)
            if(this.model.history) {
              this.payment_history = []
              this.model.history.forEach(r => this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r));
            }

            // set days
            // this.model.start = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-01')
            // this.model.end = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-'+moment(this.model.apply_date, 'YYYYMM').daysInMonth())

            console.log(this.model)
          })
          .catch(e => ( console.log(e) && this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
      }
    },
    refresh(id) {
      this.$router.push({ name: 'invoice_group', params : { id : id ? id : this.$route.params.id } }); this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('invoice.detail.vue', 'created'); },
  destroyed: function() { console.log('invoice.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('invoice.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
